const contactCn = {
  breadcrumbs: { home: '首页', contact: '联系我们' },
  hero: {
    title: '与我们联系',
    subtitle: '我们在这里帮助您解决任何问题、反馈或支持需求'
  },
  quick: {
    title: '快速获得帮助',
    actions: {
      liveChat: { title: '在线聊天', desc: '获得即时帮助', cta: '开始聊天' },
      helpCenter: { title: '帮助中心', desc: '常见问题解答', cta: '查看帮助' },
      business: { title: '商务咨询', desc: '合作与协作', cta: '联系我们' }
    }
  },
  info: {
    title: '联系信息',
    service: { title: '客户服务', desc: '上午9点至晚上9点' },
    email: { title: '邮箱', desc: '我们24小时内回复' },
    address: {
      title: '地址',
      desc: '周六至周四，上午9点 - 下午6点',
      primary: '12号房屋，学院路，',
      secondary: '杜卡法基尔莫尔，古鲁达斯普尔，纳托尔 - 6440'
    }
  },
  form: {
    title: '发送消息',
    desc: '填写表格并提供您的详细信息。我们将在24小时内联系您。',
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    subject: '主题',
    message: '消息',
    messagePh: '详细写下您的问题或评论...',
    submit: '发送',
    success: '您的消息已成功发送。我们将很快联系您。'
  },
  hours: {
    title: '办公时间',
    weekdays: '周六 - 周四',
    friday: '周五',
    note: '周五我们的办公业务因公共假期而受限'
  },
  social: { title: '社交媒体' },
  faq: {
    title: '常见问题',
    subtitle: '您可能在我们的帮助部分找到答案',
    cta: '访问帮助中心'
  }
};

export default contactCn;
